/* ================= IMPORT ================= */
import { Card, Row, Col } from "react-bootstrap";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from "recharts";

/* ================= MOCK TYPE ================= */
interface ReadinessItem {
  name: string;
  value: number;
}

/* ================= MOCK DATA ================= */
const readiness: ReadinessItem[] = [
  { name: "OEM Ready", value: 65 },
  { name: "Upgrade Required", value: 25 },
  { name: "Blocked", value: 10 }
];

/* ================= COLORS ================= */
const COLORS = ["#16a34a", "#f59e0b", "#dc2626"];

/* ================= CUSTOM LABEL ================= */
const RADIAN = Math.PI / 180;

const renderCustomizedLabel = (props: any) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  } = props;

  if (!percent || percent < 0.05) return null; // ignore petits %

  const radius = innerRadius + (outerRadius - innerRadius) / 2;

  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="central"
      style={{ fontSize: "12px", fontWeight: "bold" }}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

/* ================= COMPONENT ================= */
export default function SupplierReadinessCard() {

  const total = readiness.reduce((sum, item) => sum + item.value, 0);

  const getPercent = (value: number) => {
    return Math.round((value / total) * 100);
  };

  const globalScore = getPercent(readiness[0].value);

  return (
    <Card className="border-0 shadow-sm rounded-4 h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-semibold mb-0">Supplier Readiness</h6>
          <small className="text-muted">Global status</small>
        </div>

        <Row>

          {/* CHART */}
          <Col xs={6}>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie
                  data={readiness}
                  dataKey="value"
                  innerRadius={50}
                  outerRadius={80}
                  paddingAngle={3}
                  label={renderCustomizedLabel}
                >
                  {readiness.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </Col>

          {/* STATS */}
          <Col xs={6} className="d-flex flex-column justify-content-center">

            {readiness.map((item, index) => (
              <div key={index} className="mb-2">

                <small className="text-muted">
                  {item.name}
                </small>

                <div
                  className="fw-bold"
                  style={{ color: COLORS[index] }}
                >
                  {getPercent(item.value)}%
                </div>

              </div>
            ))}

          </Col>

        </Row>

        {/* PROGRESS GLOBAL */}
        <div className="mt-3">

          <div className="d-flex justify-content-between">
            <small className="text-muted">
              Global Industrial Readiness
            </small>
            <small className="fw-bold text-success">
              {globalScore}%
            </small>
          </div>

          <div
            className="progress mt-1"
            style={{ height: "8px" }}
          >
            <div
              className="progress-bar bg-success"
              style={{ width: `${globalScore}%` }}
            ></div>
          </div>

        </div>

      </Card.Body>
    </Card>
  );
}